// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"j0-z","subtitle":"k0-z","wrapper":"l0-z","leftArrow":"m0-z","rightArrow":"n0-z"};